import 'prefixfree';
//import './jquery'; // For LoginRegisterPro
import './easing';
import './magnific';
import './simple-dd';
import './slick';
import './select2';
import './jquery.nicefileinput';
import twire        from './twire';
import intlTelInput from 'intl-tel-input';
import mapStyle     from './map-style.json';
import Cookies      from 'js-cookie';



'use strict';


/**
 * Cache
 */
var $window			= $(window);
var $document 		= $(document);
var $htmlBody 		= $('html, body');
var $body 			= $('body');
var $header 		= $('header');
var $main 			= $('main');
var $footer 		= $('footer');
var $mobileMenu 	= $('div.mobile-menu');



/**
 * Run TWire functions
 */
twire.init();


/**
 * Remove no JS class
 */
$('html').removeClass('no-js');


/**
 * Phone input
 */
var phoneInput = document.querySelector('footer input[name="phone"], body.landing-folio input[name="phone"], body.folio main input[name="phone"], div.download-form input[name="phone"]');

if (phoneInput !== null) {

	var iti = intlTelInput(phoneInput, {

	    utilsScript: './intl-tel-input-utils.js',
		initialCountry: 'auto',
		geoIpLookup: function(success, failure) {

			fetch('https://ipapi.co/json')
			.then(function(res) { return res.json(); })
			.then(function(data) { success(data.country_code); })
			.catch(function() { failure(); });

		},
		separateDialCode: true,
		strictMode: true

	});

}


/**
 * Processes Google reCAPTCHA
 */
$('form[data-twire-after-validation-function]').each(function() {

	var $this = $(this);

	// Obliged to add this since the Google one is hidden as it interferes with the dark mode button
	//See https://developers.google.com/recaptcha/docs/faq
	$this.append('<aside>This site is protected by reCAPTCHA and the Google <a target="_blank" href="https://policies.google.com/privacy">Privacy Policy</a> and <a target="_blank" href="https://policies.google.com/terms">Terms of Service</a> apply.</aside>');

});


/**
 * Processes Google reCAPTCHA
 */
window.processPhoneAndGRC = function($form) {

	// The plugin stores the dialling code separately so once the form
	// is good, set the phone field to have the correct number
	$form.find('input[name="phone')
	     .val(iti.getNumber());
		 
	grecaptcha.ready(function() {

		grecaptcha.execute($body.data('google-recaptcha-token'), {
			
			action: 'submit'
		
		}).then(function(token) {

			// If there's more than one form per page it shouldn't matter as the 
			// submitting form will always get the latest token
			$('input[name="recaptcha-response"]').val(token);

			// Now there's a response from Google, submit the form
			twire.forms.submitValidatedForm($form);

		});

	});

}


/**
 * Mobile menu
 */
$header.find('div.menu a')
       .on('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	$this.toggleClass('active');

	if ($this.hasClass('active') === true) {

		$mobileMenu.addClass('active');

		$body.addClass('menu-open');

		$header.addClass('mobile-menu-open');

	} else {

		$mobileMenu.removeClass('active');

		$body.removeClass('menu-open');

		$header.removeClass('mobile-menu-open');

	}

});


/**
 * Site map
 */
$('div.site-map a.toggle').on('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	$this.closest('li.expandable')
	     .toggleClass('active');

});


/**
 * Alt header
 */
$window.on('scroll resize', function() {

    if ($window.scrollTop() > 50) {

        $header.addClass('alt');

    } else {

        $header.removeClass('alt');

    }

});


/**
 * Site messages
 */
$('div.site-message, p.LoginRegisterNotice').each(function() {

	var $this = $(this);

	var icon = 'check';

	if ($this.hasClass('warning') === true) {

		var icon = 'exclamation-circle';

	} else if ($this.hasClass('notice') === true) {

		var icon = 'info-circle';

	} else if ($this.hasClass('error') === true || $this.hasClass('LoginRegisterError') === true) {

		var icon = 'emoji-frown';

	}

	$this.append('<a class="bi bi-x close"></a>')
	     .prepend('<span class="bi bi-' + twire.util.html(icon) + '"></span> ')
	     .find('a.close')
		 .on('click', function(e) {

		$(this).closest('div.site-message')
		       .remove();

	});
	
	if ($this.hasClass('unclosable') === true || $this.hasClass('LoginRegisterNotice') === true) {
		
		$this.find('a.close').remove();
		
	}

});


/**
 * Drop down menu highlight
 */
$('header, div.mobile-menu').find('span.child a.active')
                           .each(function() {

	var $this = $(this);

	$this.closest('span.drop-down')
	     .children('a')
		 .addClass('active');

});


/**
 * Simple DD
 */
$('header span.drop-down, main span.drop-down').simpleDD({

   noScriptLink:    '> a',
   dropdownElement: 'span.child',
   event: 'click'

});


/**
 * Menu closer
 */
$('span.child').on('click', 'a.menu-closer', function() {

	$htmlBody.trigger('click');

	$body.removeClass('menu-open');
	
});


/**
 * Concise pagination
 */
$('main div.summary div.pagination').each(function() {

	var $this = $(this);

	var $as = $this.find('a');

	$as.hide();

	// Show first 3
	$as.filter(':nth-child(1), :nth-child(2), :nth-child(3)')
	   .show();

	// Show last 3
	$as.filter(':nth-last-child(-n+3)')
	   .show();

	// Show active and 2 before and after
	var $active = $as.filter('.active');

	$active.show();

	$active.next().show();
	$active.next().next().show();

	$active.prev().show();
	$active.prev().prev().show();

	// Loop through and add ellipsis to gaps
	var lastNumber = 0;

	$as.filter(':visible')
	   .each(function() {

		var $a = $(this);

		var val = parseInt($a.text());

		if (val !== (lastNumber + 1)) {

			$a.before('<span class="ellipsis">…</span>');

		}

		lastNumber = val;

	});

});


/**
 * Clonse function
 */
$('*[data-clone]').each(function() {

	var $this = $(this);

	$this.html($($this.data('clone')).html());

});


/**
 * Inline lightbox
 */
$('a.lightbox.inline').magnificPopup({
	
	type: 'inline',
	mainClass: 'mfp-fade'
	
});


/**
 * Inline lgihtbox
 */
$('a.lightbox.iframe').magnificPopup({
	
	type: 'iframe',
	mainClass: 'mfp-fade'
	
});


/**
 * Inline lgihtbox
 */
$('a.lightbox.image').magnificPopup({
	
	type: 'image',
	mainClass: 'mfp-fade'
	
});


/**
 * Lightbox gallery
 */
$('div.lightbox.gallery').each(function() {

	$(this).magnificPopup({
		
		delegate: 'a.img',
		type: 'image',
		mainClass: 'mfp-fade',
		gallery: {
			
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1]
			
		}
		
	});

}).each(function() { // Remove duplicates per https://www.texelate.co.uk/blog/how-to-remove-gallery-duplicates-from-magnific-popup

	var items = [];

	var $gallery = $(this);

	// Get links
	$gallery.find('a.img').each(function() {

		items.push($(this).attr('href'));

	});

	var uniqueItems = [];

	// Remove duplicates
	$.each(items, function(i, el) {

		if($.inArray(el, uniqueItems) === -1) {

			uniqueItems.push(el);

		}

	});

	items = [];

	// Put in Magnific format
	$.each(uniqueItems, function(i, el) {

		items.push({

			src: el,
			type: 'image'

		});

	});

	// Assign an index to each link so the clicked one is shown first
	$gallery.find('a.img').each(function() {

		var $a = $(this);

		$.each(items, function(i, el) {

			if (el.src == $a.attr('href')) {

				$a.data('index', i);

				return;

			}

		});

	});

	$gallery.on('click', 'a.img', function(e) {

		e.preventDefault();

		var $a = $(this);

		$.magnificPopup.open({

			type: 'image',
			items: items,
			gallery: {

				enabled: true

			}

		});

		$.magnificPopup.instance.goTo($a.data('index'));

	});

});


/**
 * Slick
 */
$('div[data-slick]').slick();


/**
 * Custom file upload
 */
$('main input[type="file"]').nicefileinput({

	label : 'Choose CV…'

});


/**
 * Job click
 */
$('main a[data-job]').on('click', function(e) {
	
	e.preventDefault();
	
	$main.find('form[data-twire-form-name="cv"] select[name="role"]')
	     .val($(this).data('job'))
		 .trigger('change');
	
});


/**
 * Select2
 */
$('select:not(.search)').select2({

	width:                   '100%',
	minimumResultsForSearch: -1

});

$('select.search').select2({

	width:                   '100%',
	minimumResultsForSearch: 2

});


/**
 * Show download form once PDF button is clicked
 * - must be done before data-scroll-to
 */
$main.find('div.pdfs a.button.restricted')
      .on('click', function(e) {

	e.preventDefault();

	var $a = $(this);

	$main.find('div.download-form-parent')
	     .slideDown();

	Cookies.set('af-download-link', {

		pageTitle:		$main.find('h1').text(),
		pageURL:		window.location.pathname,
		downloadTitle:	$a.text(),
		downloadURL:	$a.data('url')

	}, {

		expires: 30 // 1 month

	});

});


/**
 * Scroll links
 */
$('a[data-scroll-to]').on('click', function(e) {

	e.preventDefault();
	
	$htmlBody.animate({

		scrollTop: $($(this).data('scroll-to')).offset().top - 100

	}, 1000, 'easeInOutExpo');

}).addClass('active');


/**
 * Check for CV after careers form validated
 */
window.checkCVNotEmpty = function($form) {

	if ($form.find('input[name="cv"]').val() === '') {

		alert('Please uplaod your CV');

		twire.forms.addValidationHandler($form);


	} else {

		twire.forms.submitValidatedForm($form);

	}
	
}


/**
 * Form value setter
 */
$('a.form-value-setter').on('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	var $el = $($this.data('el'));

	$el.val($this.data('value'));

});


/**
 * Sales and developments search form
 */
$('body.sales, body.developments').each(function() {

	var $searchForm	= $main.find('div.search-form');
	var $form 		= $searchForm.find('form');

	 // Order link
	 $main.find('div.order span.child a')
	      .on('click', function(e) {

		e.preventDefault();

		var $this = $(this);

		$this.closest('span.drop-down')
		     .find('> a span.label')
			 .text($this.text());

		$form.trigger('submit');

	});

	// Populate areas when location selected
	$searchForm.find('span.drop-down.single.location span.child a[data-value], span.drop-down.single.location span.child a.any')
	           .on('click', function(e) {

		e.preventDefault();

		var $a = $(this);

		if ($a.hasClass('any') === true) {

			$searchForm.find('span.drop-down.single.area span.child')
			           .html('&nbsp; Please choose a location');

			$searchForm.find('input[name="location"]').val('');

		} else {

			$searchForm.find('span.drop-down.single.area span.child')
			           .html($searchForm.find('span.drop-down.single.area template[data-location="' + $a.data('value') + '"]').html());

			$searchForm.find('input[name="location"]').val($a.data('value'));

		}

		// Update front end
		$a.closest('span.drop-down')
		  .find('span.value')
		  .text($a.text());

	});


	// Single drop down
	$searchForm.find('span.drop-down.single:not(.location) span.child')
	           .on('click', 'a[data-value]', function(e) {

		e.preventDefault();

		var $a = $(this);
		
		// Update form value
		$form.find('input[name="' + $a.data('field') + '"]')
		     .val($a.data('value'));

		// Update front end
		$a.closest('span.drop-down')
		  .find('span.value')
		  .text($a.text());

	});

	// Multiple drop down
	$searchForm.find('span.drop-down.multiple span.child a[data-value]')
	           .on('click', function(e) {

		e.preventDefault();

		var $a = $(this);

		// Toggle active class
		$a.toggleClass('active');

		// Go through all and create comma-separated list
		var $siblings = $a.parent()
		                  .children(); // Not sure why this works and siblings() doesn't

		var list 			= '';
		var numSelected 	= 0;
		var labels			= '';

		$siblings.each(function() {

			var $this = $(this);

			if ($this.hasClass('active') === true) {

				list += $this.data('value');
				list += ',';

				labels += $this.text();
				labels += ', ';

				numSelected ++;

			}

		});

		list 	= list.substring(0, list.length - 1);
		labels 	= labels.substring(0, labels.length - 2);

		// Update form value
		$form.find('input[name="' + $a.data('field') + '"]')
		     .val(list);


		// Update num selected
		$a.closest('span.drop-down')
		  .find('span.num-selected')
		  .text(numSelected + ' selected');

		// Update labels
		$a.closest('span.drop-down')
		  .find('span.value')
		  .text(labels);

	});

	// Search options for mobile
	$('a.toggle-search-options').on('click', function(e) {

		e.preventDefault();

		var $this = $(this);

		$this.toggleClass('active');

		if ($this.hasClass('active') === true) {

			$searchForm .addClass('active');

		} else {

			$searchForm.removeClass('active');

		}

	});

	// For mobiles, span.drop-dpwn should have a class to manage visibility of panels
	$form.find('span.drop-down')
	     .on('click', function(e) {

		$(this).toggleClass('mobile-active');

	});


});


/**
 * Map
 */
$main.find('div.map')
     .each(function() {
	
	var $map = $(this);
	
	var coordinates = $map.data('coordinates');
	
	var location = new google.maps.LatLng(coordinates.lat, coordinates.lng);
	
	var markers = [];

	var map = new google.maps.Map($map[0], {

		center: location,
		zoom: 12,
		scrollwheel: false,
		zoomControl: true,
		styles: mapStyle

	});
		
	location = new google.maps.LatLng(coordinates.lat, coordinates.lng);
	
	var marker = new google.maps.Marker({

		map: map,
		position: location,
		icon: {

			url: '/assets/img/gui/marker.png',
			scaledSize: new google.maps.Size(50, 50)

		}

	});

});


/**
 * Home scripts
 */
$('body.home').each(function() {

	// Property form
	var $form = $main.find('form.property-search');

	// Change the second drop down
	$form.find('select[data-property-type]')
	     .on('change', function() {

		var $select = $(this);

		$form.find('select[data-location]').html($form.find('template[data-template="' + $select.val() + '"]').html());

		// Set the action
		$form.attr('action', $select.find(':selected').data('action'));

		// If empty, rmeove the location
		if ($select.val() == 'empty') {

			$form.find('input[name="location"]')
			     .val('');

		}

	});

	// Update the ID
	$form.find('select[data-location]')
	     .on('change', function() {

		var $select = $(this);

		$form.find('input[name="location"]')
		     .val($select.find(':selected').val());

	});

	// On submit, if action is # or location is empty return false
	$form.on('submit', function() {

		if ($form.attr('action') == '#' || $form.find('input[name="location"]').val() === '') {

			alert('Please choose a property type and area');

			return false;

		}

		return true;

	});

});


/**
 * Breadcrumb
 */
var $breadcrumb = $main.find('template[data-name="breadcrumb"]');

if ($breadcrumb.length === 1) {

	$main.find('div.banner div.content')
	     .prepend($breadcrumb.html());

}


/**
 * Move sale and development search forms to banner
 */
$('body.developments div.search-form, body.sales div.search-form').each(function() {


	var $this 	= $(this);
	var $banner = $main.find('div.banner div.content');
	var $a 		= $main.find('a.toggle-search-options');

	$banner.append($a);
	$banner.append($this);


});


/**
 * Triggers
 */
$window.trigger('resize');
$window.trigger('scroll');